import React from 'react';
import {
	FormattedMessage,
	defineMessages,
} from 'react-intl';

import GraphQL from '~/types/graphql';

import DotInterfaceHint from '~/components/logic/DotInterfaceHint';



const messages = defineMessages({
	message: {
		id: 'ui.interfaceHints.hint.coBranding',
	},
});



type Props = {
	children: React.ReactNode,
	isTeamLogoActive: boolean,
};

const CobrandingUploadHint: React.FC<Props> = (props) => {
	const {
		children,
		isTeamLogoActive,
	} = props;

	return (
		<DotInterfaceHint
			content={(
				<FormattedMessage {...messages.message} />
			)}
			iconPosition={{
				left: 120,
				bottom: 8,
			}}
			isObsolete={isTeamLogoActive}
			name={GraphQL.InterfaceHint.CobrandingUpload}
		>
			{children}
		</DotInterfaceHint>
	);
};



export default React.memo(CobrandingUploadHint);
